import React from 'react'
import { useAppContext } from '../libs/contextLib'
import Mooncat from './Mooncat'

export default function MyCats() {

  const { myCats, login, ownedWrappedCatIds } = useAppContext()

  return (
    <div>
      <div>WARNING: early prototype. Might not display all Mooncats or display them correctly. If you transferred them from other address they are not displayed (yet)</div>
      <button className="button" onClick={login} style={{ margin: '2rem'}} >Connect Metamask</button>

      <h1 className="title">My wrapped MoonCats ( {ownedWrappedCatIds.length} )</h1>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'bottom', marginTop: 20 }}>
        {ownedWrappedCatIds.map(catId => <Mooncat key={catId} catId={catId} />)}
      </div>

      <h1 className="title">My rescued MoonCats ( {myCats.length} )</h1>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'bottom', marginTop: 20 }}>
        {myCats.map(catId => <Mooncat key={catId} catId={catId} />)}
      </div>
    </div>
  )
}
